import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ClothingPage = lazy(() => import('../pages/clothing/page'));
const AccessoriesPage = lazy(() => import('../pages/accessories/page'));
const ThemesPage = lazy(() => import('../pages/themes/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ProductDetailPage = lazy(() => import('../pages/product-detail/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const FlyerPage = lazy(() => import('../pages/flyer/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/product/:id',
    element: <ProductDetailPage />,
  },
  {
    path: '/clothing',
    element: <ClothingPage />,
  },
  {
    path: '/accessories',
    element: <AccessoriesPage />,
  },
  {
    path: '/themes',
    element: <ThemesPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/flyer',
    element: <FlyerPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
